module.exports = __webpack_public_path__ + "img/list-pattern3.3fe6dab.svg";